import { HIDDEN } from '../classnames/design-system';
import {
  UGC_SELECTOR,
  UGC_SELECTOR_FEED,
  UGC_SELECTOR_FEED_ACTIVE,
  UGC_SELECTOR_ITEM,
  UGC_SELECTOR_ITEM_ACTIVE
} from '../classnames/ugc-selector';

export default class UgcSelectorHandler {
  containers = [];

  handleClick = (e) => {
    const parentContainer = e.target.closest(`.${UGC_SELECTOR}`);
    const { groupId } = e.target.dataset;

    parentContainer.querySelectorAll(`.${UGC_SELECTOR_FEED}`).forEach((feed) => {
      feed.classList.toggle(UGC_SELECTOR_FEED_ACTIVE, feed.dataset.groupId === groupId);
      feed.classList.toggle(HIDDEN, feed.dataset.groupId !== groupId);
    });

    parentContainer.querySelectorAll(`.${UGC_SELECTOR_ITEM}`).forEach((groupName) => {
      groupName.classList.toggle(UGC_SELECTOR_ITEM_ACTIVE, groupName.dataset.groupId === groupId);
    });
  };

  initialize() {
    this.containers = document.querySelectorAll(`.${UGC_SELECTOR}`);

    this.containers.forEach((container) => {
      const items = container.querySelectorAll(`.${UGC_SELECTOR_ITEM}`);

      items.forEach((item) => {
        item.addEventListener('click', this.handleClick);
      });
    });
  }
}
